var map = {
	"./sick0.jpeg": 7071,
	"./sick1.jpg": 2239,
	"./sick10.jpeg": 6584,
	"./sick2.jpg": 7904,
	"./sick3.jpg": 8829,
	"./sick4.jpeg": 9203,
	"./sick5.jpeg": 3276,
	"./sick99.jpeg": 9103
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7444;